import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const CropsList = () => import(/* webpackChunkName: "crops" */ '@/views/Crops/List.vue');
const CropCreate = () => import(/* webpackChunkName: "crops" */ '@/views/Crops/Create.vue');
const CropEdit = () => import(/* webpackChunkName: "crops" */ '@/views/Crops/Edit.vue');

let cropsPages = {
  path: '/crops',
  redirect: '/crops',
  component: DashboardLayout,
  name: 'Crops',
  meta: {
    title: 'Cultivos',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'CropsList',
      meta: {
        title: 'Listado',
        auth: ['crops.index'],
      },
      component: CropsList,
    },
    {
      path: 'create',
      name: 'CropCreate',
      meta: {
        title: 'Nuevo',
        auth: ['crops.store'],
      },
      component: CropCreate,
    },
    {
      path: ':id/edit',
      name: 'CropEdit',
      meta: {
        title: 'Editar',
        auth: ['crops.update'],
      },
      component: CropEdit,
    },
  ],
};

export default cropsPages;
